import React from 'react';

const DEFAULT_LABELS = [
  'Building research plan',
  'Executing research task 1',
  'Executing research task 2',
  'Executing research task 3',
  'Evaluating research quality',
  'Follow-up research if needed',
  'Synthesizing final report',
];

const styles = {
  wrap: { marginBottom: '48px', animation: 'fadeUp 0.4s ease both' },
  header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' },
  title: { fontFamily: 'var(--font-head)', fontSize: '13px', color: 'var(--neon)', letterSpacing: '0.15em' },
  right: { display: 'flex', alignItems: 'center', gap: '16px' },
  agentBadge: {
    display: 'inline-flex', alignItems: 'center', gap: '8px',
    fontFamily: 'var(--font-mono)', fontSize: '12px', color: 'var(--neon2)',
    border: '1px solid rgba(123,92,255,0.3)', background: 'rgba(123,92,255,0.07)',
    padding: '5px 14px', borderRadius: '3px',
  },
  company: { fontFamily: 'var(--font-mono)', fontSize: '13px', color: 'var(--text2)' },
  grid: { display: 'flex', flexDirection: 'column', gap: '10px' },
  card: {
    background: 'var(--panel)', border: '1px solid var(--border)', borderRadius: '6px',
    padding: '16px 22px', display: 'flex', alignItems: 'center', gap: '18px',
    transition: 'border-color 0.3s, background 0.3s',
  },
  cardActive: { borderColor: 'var(--neon)', background: 'rgba(0,255,231,0.04)' },
  cardDone: { borderColor: 'rgba(0,255,231,0.4)' },
  icon: { fontFamily: 'var(--font-mono)', fontSize: '16px', color: 'var(--text3)', width: '20px', textAlign: 'center', flexShrink: 0 },
  iconActive: { color: 'var(--neon)', animation: 'blink 0.8s infinite' },
  iconDone: { color: 'var(--neon)' },
  num: { fontFamily: 'var(--font-mono)', fontSize: '11px', color: 'var(--text3)', width: '60px', flexShrink: 0 },
  numActive: { color: 'var(--neon)' },
  label: { fontSize: '14px', color: 'var(--text2)', lineHeight: 1.5, flex: 1 },
  labelActive: { color: 'var(--text)' },
  dot: { width: '8px', height: '8px', borderRadius: '50%', flexShrink: 0 },
};

export default function AgentProgress({ currentStep, company, stepLabels = {} }) {
  return (
    <div style={styles.wrap}>
      <div style={styles.header}>
        <div style={styles.title}>// AGENT LOOP EXECUTING</div>
        <div style={styles.right}>
          <div style={styles.agentBadge}>
            <span style={{ animation: 'blink 1s infinite' }}>◈</span> TRUE AGENT MODE
          </div>
          <div style={styles.company}>{company.toUpperCase()}</div>
        </div>
      </div>
      <div style={styles.grid}>
        {DEFAULT_LABELS.map((defaultLabel, idx) => {
          const stepNum = idx + 1;
          const isActive = stepNum === currentStep;
          const isDone = stepNum < currentStep;
          const isPending = stepNum > currentStep;

          // Hide steps that are far ahead and haven't been touched
          if (isPending && stepNum > currentStep + 1) return null;

          const dynamicLabel = stepLabels[stepNum]?.label || defaultLabel;

          return (
            <div key={stepNum} style={{ ...styles.card, ...(isActive ? styles.cardActive : {}), ...(isDone ? styles.cardDone : {}) }}>
              <div style={{ ...styles.icon, ...(isActive ? styles.iconActive : {}), ...(isDone ? styles.iconDone : {}) }}>
                {isDone ? '✦' : isActive ? '◈' : '○'}
              </div>
              <div style={{ ...styles.num, ...(isActive || isDone ? styles.numActive : {}) }}>STEP 0{stepNum}</div>
              <div style={{ ...styles.label, ...(isActive ? styles.labelActive : {}) }}>{dynamicLabel}</div>
              <div style={{ ...styles.dot, background: isDone ? 'var(--neon)' : isActive ? 'var(--neon)' : 'var(--text3)', animation: isActive ? 'pulse 1s infinite' : 'none', opacity: isDone ? 1 : isActive ? 1 : 0.3 }} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
